import { Alert, List, ListGroupItem } from 'reactstrap';
import { getDashColor } from '~/shared/components/icons';
import { RxCrossCircled } from 'react-icons/rx';
import { useContext, useState } from 'react';
import { FundRequestContext } from '~/context/fundrequests';
function RequiredInfoAlert({
    expenseItemsHasFlags,
}: {
    expenseItemsHasFlags: boolean;
}) {
    const [{ fundRequest, selectedPayee }, fundRequestDispatch] =
        useContext(FundRequestContext);
    const [toggleAlert, setToggleAlert] = useState(true);

    const handleToggle = () => {
        setToggleAlert(false);
    };

    if (!toggleAlert) return <></>;

    // Find the status note from the notes array (needs_info status or current status non-client note)
    const statusNote = fundRequest?.notes?.find(note => 
        note.fund_request_status?.value === 'needs_info' ||
        (note.fund_request_status?.value === fundRequest.fund_request_status.value && !note.is_client_note)
    );
    const infoNote = statusNote?.note;
    // When a payee is selected, check the vendor's ach_last_4 directly
    // This handles the case where user swaps to a vendor that already has ACH info
    const needsAchInfo = selectedPayee
        ? !selectedPayee.ach_last_4  // Use selected vendor's ACH status
        : fundRequest?.needs_ach_info || false;  // Fall back to saved fund request value

    return (
        <Alert
            style={{
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
                backgroundColor: getDashColor('message'),
                borderColor: getDashColor('message'),
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.25)',
                color: 'white',
                marginRight: '-40px',
            }}
        >
            <RxCrossCircled
                onClick={handleToggle}
                style={{
                    position: 'absolute',
                    top: '30px',
                    right: '25px',
                    fontSize: '1.5rem',
                    color: 'white',
                    cursor: 'pointer',
                }}
            />
            <div
                className='eyebrow'
                style={{
                    marginBottom: '18px',
                    color: 'white',
                }}
            >
                Additional Info Required
            </div>
            <List>
                {needsAchInfo && (
                    <ListGroupItem>Need ACH information</ListGroupItem>
                )}
                {expenseItemsHasFlags && (
                    <ListGroupItem>
                        Review the Expense Items below
                    </ListGroupItem>
                )}
                {infoNote && <ListGroupItem>{infoNote}</ListGroupItem>}
            </List>
        </Alert>
    );
}

export default RequiredInfoAlert;
